import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "linkComponent"];
import React from 'react';
import { SectionLink } from './search-result-section-link.styled';
export var SearchResultSectionLink = function SearchResultSectionLink(_ref) {
  var children = _ref.children,
    linkComponent = _ref.linkComponent,
    rest = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    /* component must either be `undefined` or an component. A null or false will throw an error */
    React.createElement(SectionLink, _extends({
      appearance: "link"
    }, rest, {
      component: linkComponent || undefined
    }), children)
  );
};